import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Dialogic from './Dialogic.vue'
import BackupRestoreResult from './BackupRestoreResult.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dialogic, null, {
    default: _withCtx((slotProps) => [
      _createVNode(BackupRestoreResult, {
        close: slotProps.close
      }, null, 8, ["close"])
    ]),
    _: 1
  }))
}
}

})